import { tagCategories } from '../components/MusicFormFields';

const tagTranslationMap = Object.values(tagCategories).reduce((map, category) => {
  category.tags.forEach(({ value, translationKey }) => {
    map[value] = translationKey;
  });
  return map;
}, {});

export const getTagTranslationKey = (tag) => {
  const normalized = String(tag || '').trim();
  return normalized ? tagTranslationMap[normalized] || null : null;
};

export const translateTag = (tag, t) => {
  const normalized = String(tag || '').trim();
  if (!normalized) {
    return normalized;
  }
  const translationKey = getTagTranslationKey(normalized);
  return translationKey ? t(translationKey) : normalized;
};
